<app-dialog
  headerText="Move Operation: Details"
  i18n-headerText="
    XTIT|Title for move resource operation status@@moveResourceStatus.title"
  [showSaveButton]="false"
  [showTopCancelButton]="false"
  cancelText="Close"
  [body]="body"
  (cancel)="onClose()"
>
</app-dialog>

<ng-template #body>
  <div class="move-status-details-container">
    <div class="operation-id-wrap">
      <app-details-row
        class="move-status-details-row"
        label="Operation ID"
        [value]="operationId"
      >
      </app-details-row>
      <button
        fd-button
        fdType="transparent"
        class="copy-button link-color"
        (click)="onCopyOperationId()"
      >
        <app-icon icon="copy" size="1x"></app-icon>
      </button>
    </div>
    <app-details-row
      class="move-status-details-row"
      label="Message"
      [value]="message"
    ></app-details-row>
    <app-details-row
      class="move-status-details-row"
      label="State"
      [value]="state"
    ></app-details-row>
    @if (errorsMap.size > 0) {
      <div>
        <h3>Errors</h3>
        @for (error of errorsMap | keyvalue; track error) {
          <div class="move-status-errors">
            <app-details-row
              label="Controller"
              [value]="error.key"
            ></app-details-row>
            <app-details-row
              label="Message"
              [value]="error.value"
            ></app-details-row>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
